import axios from 'axios'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getBackendUrl } from '../../../api'
import { useSnackbar } from '../../../providers/SnackbarProvider'
import { CTAMap } from '../ctaData'
const SERVER_URL = getBackendUrl()

const useJobCards = () => {
    const [jobCards, setJobCards] = useState()
    const [bookingSummary, setBookingSummary] = useState()
    const { bookingId } = useParams()
    const [selectedTab, setSelectedTab] = useState('READY_TO_DEPLOY')
    const handelTabChange = useCallback((e, val) => {
        setSelectedTab(val)
    }, [])
    useEffect(() => {
        if (!bookingSummary) return
        if (selectedTab === 'DEPLOYMENT_COMPLETE') return
        setSelectedTab([...Object.keys({ ...CTAMap[bookingSummary?.status?.enumValue]?.tabs })][0] ?? 'READY_TO_DEPLOY')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookingSummary])

    const { showSnackbar } = useSnackbar()
    const fetchJobCards = useCallback(async () => {
        try {
            const { data } = await axios.get(
                `${SERVER_URL}/customers/bookings/${bookingId}/workers?status=${selectedTab}`
            )
            setJobCards(data.payload.workerCards)
        } catch (errors) {
            showSnackbar({
                msg: errors.response.data.developerInfo,
                sev: 'error',
            })
        }
    }, [bookingId, selectedTab, showSnackbar])
    const fetchBookingSummary = useCallback(async () => {
        try {
            const { data } = await axios.get(`${SERVER_URL}/customers/bookings?bookingId=${bookingId}`)
            setBookingSummary(data.payload.response.bookings[0])
        } catch (errors) {
            showSnackbar({
                msg: errors.response.data.developerInfo,
                sev: 'error',
            })
        }
    }, [bookingId, showSnackbar])
    useEffect(() => {
        fetchJobCards()
        fetchBookingSummary()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTab])

    const helperCards = useMemo(() => {
        return [...(jobCards?.filter((item) => item?.skillType === 'HELPER') ?? [])]
    }, [jobCards])
    const technicianCards = useMemo(() => {
        return [...(jobCards?.filter((item) => item?.skillType === 'TECHNICIAN') ?? [])]
    }, [jobCards])
    const supervisorCards = useMemo(() => {
        return [...(jobCards?.filter((item) => item?.skillType === 'SUPERVISOR') ?? [])]
    }, [jobCards])

    return useMemo(
        () => ({
            selectedTab: selectedTab,
            handelTabChange: handelTabChange,
            bookingSummary: bookingSummary,
            helperCards: helperCards,
            technicianCards: technicianCards,
            supervisorCards: supervisorCards,
        }),
        [selectedTab, handelTabChange, bookingSummary, helperCards, technicianCards, supervisorCards]
    )
}

export default useJobCards
